import React from "react";
import "./HTMate.scss";

const HTMateData = () => {
  return (
    <div
      className="data-container"
      // style={{ backgroundImage:
      //     "url('../../assets/images/backgrounds/2.jpg')"}}
    >
      <div className="textitem">
        <h5>About HTMate</h5>
        <p>
          "HTMate" is a Clinical EHR (Electronic Health Record) developed by
          Hlthtek Optimus Private Ltd. for Indian Healthcare Markets. This tool
          is leveraging a scalable and secured (HIPAA enabled) platform on
          Amazon Web Service (AWS) Cloud under a very futuristic, constant and
          emerging roadmap. However, the "HTMate" has the following features
          presently:
        </p>
        <ul>
          <li>Appointment Queue</li>
          <li>Historical Digital Records</li>
          <li>Wellness & Profile Records</li>
          <li>OP Consultation by Health Professionals</li>
          <li>e-Prescription Tool</li>
          <li>Clinical Suggestions for Doctors</li>
          <li>Medical Codifications (SNOWMED CT & LOINC) on Selective Data</li>
          <li>Health Analytics for Doctors</li>
          <li>Inventory, Billing & Invoicing</li>
          <li>BI Reports (MIS)</li>
          <li>ABDM Enablement & Interoperability (Optional)</li>
        </ul>
      </div>
      <div className="textitem">
        <h5>Types of User Roles supported in the HTMate System</h5>
        <ul>
          <li>Hlthtek Admin – Termed as Super User</li>
          <li>Partner Admin – Admin for each Partner Organization</li>
          <li>Customer Admin – Admin for each Customer</li>
          <li>Facility Admin – Admin for each Customer facility</li>
          <li>Facility User – User for each Customer facility</li>
          <li>
            Doctor’s Assistant User - Facility user of Customer who assists
            doctors
          </li>
          <li>Doctors - Customer's Health Professionals</li>
          <li>Lab User - User for Laboratory & Diagnostics</li>
          <li>Pharmacy User - User for Pharmacy</li>
          <li>Reports/Accounts User - User for Reports (Pending)</li>
        </ul>
      </div>
    </div>
  );
};

export default HTMateData;
